import { useEffect, useState } from "react"

import { listLeadEnvelopes } from "../api/esign.services.ts"
import { isCountersigner } from "../helpers/countersigner.ts"
import type { RecipientStatus, SigningEnvelope } from "../types/esign.types.ts"
import { useCanCountersign } from "./use-countersign.ts"

const FINISHED: readonly RecipientStatus[] = ["signed", "declined"]

// The others' statuses decide: the contractor's own row may read sent, viewed or consented by now.
const isAwaitingCountersignature = (envelope: SigningEnvelope) =>
  ["sent", "partially_signed"].includes(envelope.status) &&
  envelope.recipients.some(
    (recipient) =>
      isCountersigner(recipient) && !FINISHED.includes(recipient.status)
  ) &&
  envelope.recipients
    .filter(
      (recipient) => recipient.role === "signer" && !isCountersigner(recipient)
    )
    .every((recipient) => recipient.status === "signed")

// A hint only: a failed read leaves it empty.
export const useAwaitingCountersignature = (leadId: string | undefined) => {
  const canCountersign = useCanCountersign()
  const [envelopes, setEnvelopes] = useState<SigningEnvelope[]>([])

  useEffect(() => {
    setEnvelopes([])
    if (!canCountersign || !leadId) return
    let abandoned = false
    void listLeadEnvelopes(leadId).then((result) => {
      if (abandoned) return
      setEnvelopes(
        result.ok && result.data
          ? result.data.filter(isAwaitingCountersignature)
          : []
      )
    })
    return () => {
      abandoned = true
    }
  }, [canCountersign, leadId])

  return envelopes
}
